import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginFormComponent } from './login-form/login-form.component';
import { XnFormModule } from '../ui-components/xn-form/xn-form.module';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { TabViewModule } from '../ui-components/tab-view/tab-view-module';


@NgModule({
  declarations: [
    LoginFormComponent
  ],
  imports: [
    CommonModule,
    XnFormModule,
    TabViewModule,
    ConfirmDialogModule,
    ToastModule,
    TranslateModule,
    DialogModule,
  ],
  exports: [
    LoginFormComponent,
  ]
})
export class AuthModule { }
